module.exports = __webpack_public_path__ + "media/Smart_UI.8ebe3067.wav";